type TemplateValue = {$template: string | number};

const isTemplateValue = (value: unknown): value is TemplateValue =>
  typeof value === 'object' &&
  value !== null &&
  '$template' in value &&
  (typeof value.$template === 'string' || typeof value.$template === 'number');

/**
 * Some fields F16/I177/O39/I211 store a literal `{$template: '<index>'}`
 * rather than a plain string once selected
 */
export const resolveSelectorIndex = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value;
  if (isTemplateValue(value)) return String(value.$template);
  return undefined;
};
